var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "add-to-basket-container" }, [
    _c(
      "button",
      {
        staticClass: "btn btn-block btn-primary btn-appearance",
        attrs: { disabled: _vm.isLoading },
        on: {
          click: function($event) {
            return _vm.addToBasket()
          }
        }
      },
      [
        _c("icon", {
          attrs: { icon: "shopping-cart", waiting: _vm.isLoading }
        }),
        _vm._v(
          "\n    " +
            _vm._s(_vm.$translate("Ceres::Template.singleItemAddToBasket")) +
            "\n  "
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }